import { DataManager } from "@/data-manager";

class DownloadStatus {
  [key: string]: {
    name: string;
    state: string;
  };

  animals = {
    name: "Animals",
    state: "idle"
  };
  "animal-morbidities" = {
    name: "Animal Morbidities",
    state: "idle"
  };
  kraals = {
    name: "Kraals",
    state: "idle"
  };
  lines = {
    name: "Lines",
    state: "idle"
  };
  treatments = {
    name: "Treatments",
    state: "idle"
  };
  "treatment-compositions" = {
    name: "Treatment Compositions",
    state: "idle"
  };
  "morbidity-reasons" = {
    name: "Morbidity Reasons",
    state: "idle"
  };
  "species-codes" = {
    name: "Species Codes",
    state: "idle"
  };
  "dispensary-items" = {
    name: "Dispensary Items",
    state: "idle"
  };
  "reader-location-descriptions" = {
    name: "Reader Location Descriptions",
    state: "idle"
  };
  "kraal-morbidities" = {
    name: "Kraal Morbidities",
    state: "idle"
  };
  "kraal-morbidity-histories" = {
    name: "Kraal Morbidity Histories",
    state: "idle"
  };
  "tag-reader-location-infos" = {
    name: "Tag Reader Location Info",
    state: "idle"
  };
}

export default class RootState {
  dataManager: DataManager;
  downloadStatus: DownloadStatus;
}

export { DownloadStatus };